import type { Notification, NotificationItem } from "@kontextwerk/control-web-client"

const asObject = (value: unknown): Record<string, unknown> =>
  value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {}

const actionCaseId = (item: NotificationItem): string =>
  item.item_kind === "ACTION_CASE" && typeof item.action_case_id === "string"
    ? item.action_case_id.trim()
    : ""

export const notificationActionCaseIds = (notification: Notification): string[] => {
  const ids: string[] = []
  for (const item of notification.items) {
    const id = actionCaseId(item)

    if (id && !ids.includes(id)) ids.push(id)
  }

  return ids
}

export const flowKeyFromTodos = (todos: Notification[]): string => {
  for (const todo of todos) {
    const payload = asObject(todo.payload)
    const value = typeof payload.flow_key === "string" ? payload.flow_key.trim() : ""

    if (value) return value
  }

  return ""
}

export const actionCaseIdsFromTodos = (todos: Notification[]): string[] => {
  const ids: string[] = []
  for (const todo of todos) {
    for (const id of notificationActionCaseIds(todo)) {
      if (id && !ids.includes(id)) ids.push(id)
    }
  }

  return ids
}

export const organizationIdFromTodos = (todos: Notification[]): string | null => {
  for (const todo of todos) {
    if (typeof todo.organization_id === "string" && todo.organization_id.trim()) {
      return todo.organization_id.trim()
    }
  }

  return null
}
